import { useRiskProfileQuery } from './useRiskProfileQuery'
import type { RiskProfileQueryParams } from './useRiskProfileQueryParams'
import { useRiskProfileRequest } from './useRiskProfileRequest'

export function useProfileElementGroupData(queryParams: RiskProfileQueryParams | null) {
  const request = useRiskProfileRequest({ queryParams, widget: 'riskByElementGroup' })
  const query = useRiskProfileQuery(request as Parameters<typeof useRiskProfileQuery>[0])
  return { request, query }
}
